import React from 'react';
import Select from 'react-select';

const CommonSelect = ({
  options,
  name,
  value,
  onChange,
  disabled = false,
  className,
  backgroundColor,
  placeholder = 'Select...',
  controlCustomStyle,
  inputCustomStyle,
  singleValueCustomStyle,
  dropdownIndicatorCustomStyle,
  placeholderCustomStyle,
  borderColor,
  color,
  isMulti = false,
  radius
}) => {
  const theme = localStorage.getItem('selectedTheme');

  return (
    <>
      <Select
        options={options}
        name={name}
        onFocus={false}
        isDisabled={disabled}
        value={value}
        isMulti={isMulti}
        onChange={onChange}
        placeholder={placeholder}
        className={className}
        styles={{
          control: (baseStyles) => ({
            ...baseStyles,
            height: isMulti ? 'auto' : '40px',
            fontSize: '14px',
            border:
              theme === 'true'
                ? '1.5px solid #171D2F'
                : borderColor
                ? '1.5px solid #d1d5db'
                : '1.5px solid #E7E8EA',
            backgroundColor:
              theme === 'true' ? '#171D2F' : backgroundColor ? backgroundColor : '#F4F4F4',
            borderRadius: radius ? radius : '0.5rem',
            transition: 'none',
            outline: 'none',
            boxShadow: 'none',
            color: theme === 'true' ? '#000' : '#0B1D2E',
            ':hover': {
              border: theme === 'true' ? '1.5px solid #171D2F' : '1.5px solid #E7E8EA',
              outline: 'none',
              boxShadow: 'none'
            },
            ...controlCustomStyle
          }),
          menu: (baseStyles) => ({
            ...baseStyles,
            backgroundColor: theme === 'true' ? '#171D2F' : '#fff',
            borderRadius: '0.5rem',
            fontSize: '14px'
          }),
          option: (baseStyles, { isFocused, isSelected }) => ({
            ...baseStyles,
            fontSize: '14px',
            backgroundColor:
              theme === 'true'
                ? isSelected
                  ? ''
                  : isFocused
                  ? '#27264D'
                  : '#171D2F'
                : isSelected
                ? ''
                : isFocused
                ? '#EEEEEE'
                : '#fff',
            color: theme === 'true' ? '#e5eaf9' : color ? color : '#0B1D2E',
            ':hover': {
              backgroundColor: theme === 'true' ? '#27264D' : '#EEEEEE'
            }
          }),
          input: (baseStyles) => ({
            ...baseStyles,
            fontSize: '14px',
            paddingLeft: '0px',
            color: theme === 'true' ? '#e5eaf9' : color ? color : '#0B1D2E',
            ...inputCustomStyle
          }),
          placeholder: (baseStyles) => ({
            ...baseStyles,
            fontSize: '14px',
            ...placeholderCustomStyle
          }),
          singleValue: (baseStyles) => ({
            ...baseStyles,
            color: theme === 'true' ? '#e5eaf9' : color ? color : '#0B1D2E',
            fontSize: '14px',
            paddingLeft: '6px',
            ...singleValueCustomStyle
          }),
          dropdownIndicator: (baseStyles) => ({
            ...baseStyles,
            color: theme === 'true' ? '#e5eaf9' : color ? color : '#0B1D2E',
            ':hover': {
              color: theme === 'true' ? '#e5eaf9' : '#0B1D2E'
            },
            ...dropdownIndicatorCustomStyle
          })
        }}
      />
    </>
  );
};

export default CommonSelect;
